module.exports = __webpack_public_path__ + "img/working-desk-with-hands-sketching-screens-mobile-responsive-website-development-with-ui-ux.76378d2c.png";